// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ndgy","select":"styles_select__2YkPp"};